var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2372 11.7884C22.6301 11.9194 22.8425 12.3442 22.7115 12.7371L21.8782 15.2371L21.8782 15.2371L20.7115 18.7371C20.6094 19.0434 20.3228 19.25 20 19.25H15.5C15.1651 19.25 14.8709 19.028 14.7789 18.706L13.7789 15.206C13.7142 14.9797 13.7595 14.7362 13.9012 14.5483C14.043 14.3604 14.2647 14.25 14.5 14.25H20.6261L21.2885 12.2628C21.4195 11.8698 21.8442 11.6575 22.2372 11.7884ZM15.4943 15.75L16.0657 17.75H19.4594L20.1261 15.75H15.4943Z",
    fill: "#7B7D7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.012 19.9416C17.3197 20.2188 17.3445 20.693 17.0672 21.0008L17.0572 21.0119C16.78 21.3196 16.3058 21.3444 15.998 21.0671C15.6903 20.7899 15.6655 20.3156 15.9428 20.0079L15.9528 19.9968C16.23 19.689 16.7042 19.6643 17.012 19.9416Z",
    fill: "#7B7D7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.012 19.9416C20.3197 20.2188 20.3445 20.693 20.0672 21.0008L20.0572 21.0119C19.78 21.3196 19.3058 21.3444 18.998 21.0671C18.6903 20.7899 18.6655 20.3156 18.9428 20.0079L18.9528 19.9968C19.23 19.689 19.7042 19.6643 20.012 19.9416Z",
    fill: "#7B7D7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 7C4.25 4.37665 6.37665 2.25 9 2.25C11.6233 2.25 13.75 4.37664 13.75 7C13.75 9.62336 11.6233 11.75 9 11.75C6.37665 11.75 4.25 9.62335 4.25 7ZM9 3.75C7.20507 3.75 5.75 5.20507 5.75 7C5.75 8.79493 7.20507 10.25 9 10.25C10.7949 10.25 12.25 8.79492 12.25 7C12.25 5.20508 10.7949 3.75 9 3.75Z",
    fill: "#7B7D7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11.75C5.54822 11.75 2.75 14.5482 2.75 18C2.75 18.4142 2.41421 18.75 2 18.75C1.58579 18.75 1.25 18.4142 1.25 18C1.25 13.7198 4.7198 10.25 9 10.25C10.8094 10.25 12.4759 10.8711 13.7949 11.911C14.1202 12.1675 14.176 12.6391 13.9196 12.9644C13.6631 13.2896 13.1915 13.3454 12.8663 13.089C11.8023 12.2501 10.4606 11.75 9 11.75Z",
    fill: "#7B7D7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customerIcon.cc292eadd97dfe7e3069cba5315285a5.svg";
export { ForwardRef as ReactComponent };